import React from 'react';
import $ from 'jquery';
import {getFullUrlPath} from '../utils/common'; 

export default class Time extends React.Component {

	dateTimeID = 0;

	serverTimeID = 0;

	state = {
		currentdatetime: new Date(),
		utcDateTimeMs: 0,
		gmtZone: (new Date().getTimezoneOffset() / 60 * -1)
	};

	formatDateTime(date) {
		var _hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
		var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
			days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
			ampm = date.getHours() >= 12 ? 'PM' : 'AM',
			hours = _hours.toString().length == 1 ? '0' + _hours : _hours,
			minutes =
				date.getMinutes().toString().length == 1 ? '0' + date.getMinutes() : date.getMinutes(),
			seconds =
				date.getSeconds().toString().length == 1 ? '0' + date.getSeconds() : date.getSeconds(),
			timzone = this.state.gmtZone > 0 ? '+' + this.state.gmtZone : this.state.gmtZone;
        return hours + ':'+ minutes + ':'+ seconds + ' ' + ampm + ' ' +months[date.getMonth()] + ' ' +
               date.getDate() + ', ' + date.getFullYear() + ' GMT ' + timzone;
	}

	getServerTime = () => {
		$.ajax({
			url: getFullUrlPath('getServerTime.ashx'),
			cache: false,
			dataType: 'json'
		}).done(data => {
			//console.log('received data = ' + JSON.stringify(data));
			const utcDate = new Date(
				data.serverUtcTime.year,
				data.serverUtcTime.month - 1,
				data.serverUtcTime.days,
				data.serverUtcTime.hours,
				data.serverUtcTime.minutes,
				data.serverUtcTime.seconds,
				data.serverUtcTime.milliseconds
			);
			//console.log('utcDate.getTime() = ' + utcDate.getTime());

			this.setState({
				utcDateTimeMs: utcDate.getTime(),
				gmtZone: (new Date().getTimezoneOffset() / 60 * -1) //data.gmtZone
			});

			this.getDataTime();
		});
	}

	getDataTime = () => {
		
		const utc = this.state.utcDateTimeMs;
		const targetGmtDateTime = utc + 3600000 * this.state.gmtZone;
		this.setState({
			currentdatetime: this.formatDateTime(new Date(targetGmtDateTime)),
			utcDateTimeMs: this.state.utcDateTimeMs + 1000
		});
	}

	componentWillMount() {
		this.getServerTime();
	}

	componentDidMount() {
		this.dateTimeID = setInterval(this.getDataTime, 1000);
		this.serverTimeID = setInterval(this.getServerTime, 60000);
	}

	componentWillUnmount() {
		clearInterval(this.dateTimeID);
		clearInterval(this.serverTimeID);
	}

	render() {
		return (
			<div className="time" id="clock">
				{this.state.currentdatetime.toLocaleString()}
			</div>
		);
	}
}
